
import React from "react";
import { ThemeProps } from '../../genericComponents/globalStyles';
import { Button } from '../../genericComponents';
import styled from "styled-components";

const NewsHeader = ({
    toggleModal
}) => {

    return (
        <HeaderContainer>
            <HeaderContent>
                <Title>
                    <h3>News & Media</h3>
                    <p>
                        {" "}
                    Find or make something interesting? Share it with the GABA community.<br />
                    Also enjoy the other submissions!
                </p>
                </Title>
                <TutorialButton onClick={toggleModal}>
                    Submit Content
            </TutorialButton>
            </HeaderContent>
        </HeaderContainer>
    )
}

export default NewsHeader

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1170px;
  `

const HeaderContainer = styled.div`
    padding: 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    background-size: 100 % 250px;
    background-repeat: repeat-x;
    background-color: white;
    `;

const Title = styled.div`
    padding: 0px 16px 0px 0;
    width: 70%;
    color: ${ThemeProps.color.darkBlue};
    @media(max-width: 720px) {
      width: 100%;
    }
    h3 {
      font-weight: 700;
      color: ${ThemeProps.color.darkBlue};
      font-size: 3.8em;
      font-weight: bold;  
    }
    p {
      font-size: 1.4em;
    }
`;

const TutorialButton = styled(Button)`
  background-color: ${ThemeProps.color.gabaYellow};
  color: ${ThemeProps.color.darkBlue};
  padding: 15px 14px 14px;
  border-radius: 6px;
  font-size: 1.4em;
  font-weight: 500;
  text-align: center;
  min-width: 220px;
  max-height: 50px;
  @media (max-width: 720px) {
    width: 100%;
  }
`;
